import { toast } from "react-toastify";
import { GET, POST } from "../Network/snpaxios";
import { encode } from "./utils";
import { Server_Constants, WEBSITE_SHOP_HASH } from "./constant";


const isProductInWishlist = (cart, id) => {
  return cart?.find((wishlistProduct) => wishlistProduct === id)
    ? true
    : false;
};

const getWishlistProduct = async (userMobile) => {
  try {
    const encodedShopHash = encode(WEBSITE_SHOP_HASH);
    const payLoad = await GET(`ext/cart/get-product-state?shopHash=${encodedShopHash}&custMob=${userMobile}&type=${Server_Constants.IN_WHISLIST}`);
    if (payLoad !== null) {
      return payLoad?.fullData || null;
    } else {
      console.error("getWishlistProducts", "null payload");
      return null;
    }
  } catch (err) {
    console.error("getWishlistProducts", err);
    return null;
  }
};

const addRemoveProductToWishlist = async (
  item,
  productDispatch,
  userMobile,
  isAdd,
  setWishlistBtnDisabled
) => {
  setWishlistBtnDisabled(true);
  try {
    const data = {
      jcJson: {
        shopHash: encode(WEBSITE_SHOP_HASH),
        inventoryId: item.prdId,
        type: Server_Constants.IN_WHISLIST,
        custMob: userMobile,
        isAdd: isAdd,
      },
    };
    const payLoad = await POST("ext/cart/update-product-state-info", data);
    if (payLoad !== null) {
      const reducerType = isAdd ? "setWishlist" : "setRemoveWishlist";
      const idsReducerType = isAdd ? "setWishlistIds" : "setRemoveWishlistIds";
      productDispatch({ type: idsReducerType, payload: item.prdId });
      productDispatch({ type: reducerType, payload: item });
      toast.success(`Item is ${isAdd ? "added to" : "removed from"} Wishlist!`);
    }
  } catch (err) {
    console.error("addRemoveProductToWishlist: ", err);
  } finally {
    setWishlistBtnDisabled(false);
  }
};

export {
  isProductInWishlist,
  getWishlistProduct,
  addRemoveProductToWishlist,
};
